import { render } from "./CarsBusinessInsuranceExperts.vue?vue&type=template&id=c1073ba4"
import script from "./CarsBusinessInsuranceExperts.vue?vue&type=script&lang=js"
export * from "./CarsBusinessInsuranceExperts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__